export class InvoiceCorrectionPosition{
	amountToRefund: number
	invoicePositionUuid: string
	makeTicketAvailable: boolean
}



// WEBPACK FOOTER //
// ./src/app/models/invoice-correction-position.model.ts